module.exports = __webpack_public_path__ + "public/images/icon-arrow.ce0c4919dea7c3e6006de17395c40713.svg";